module.exports = __webpack_public_path__ + "img/page_image_2_9.89a83e3a.svg";